var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    tag: true,
    'tag--general': _vm.color === 'general',
    'tag--sex': _vm.color === 'sex',
    'tag--gender-identity': _vm.color === 'gender_identity',
    'tag--gender-expression': _vm.color === 'gender_expression',
    'tag--sexual-orientation': _vm.color === 'sexual_orientation',
    'tag--romantic-orientation': _vm.color === 'romantic_orientation',
  },on:{"click":function($event){return _vm.clickTag(_vm.color)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }